
import { Component, Vue, Prop } from 'vue-property-decorator';
import kebabCase from 'lodash/kebabCase';
import mapKeys from 'lodash/mapKeys';

@Component
export default class BoxGridItem extends Vue {
  @Prop({ default: '' }) itemClass!: string;

  @Prop({ default: false }) animateTransitions!: boolean | string;

  @Prop({ default: false }) useLoadingOverlay!: boolean | string;

  @Prop({ default: 'managed' }) overlayType!: 'managed' | 'simple';

  @Prop({ default: () => {} }) loadingOverlayProps!: any;

  @Prop({ required: false }) title?: string;

  get overlayProps() {
    return { variant: 'box', opacity: '0.85', ...this.loadingOverlayProps };
  }

  get showLoadingOverlay() {
    return this.useLoadingOverlay !== false;
  }

  get bColAttrs() {
    return {
      'align-self': 'start',
      ...mapKeys(this.$attrs, (v, k) => kebabCase(k)),
    };
  }
}
